const appConfig = {
  appName: "The Oven Delights",
  orderChecker: {
    autoRefresh: {
      enabled: true,
      interval: 30, // seconds
    },
  },
};

export default appConfig;
